import React from 'react';

/**
 * <Carousel id="carousel-id">
        <LateRent filter={filter} />
        <Income filter={filter} />
        <Expense filter={filter} />
 * </Carousel>
 */
export function Carousel(props) {
    const id = props.id;
    let needsActive = true;
    /**
     * ListItem component for the bootstrap carousel indicators
     */
    const ListItem = props => {
        const id = props.id;
        const i = props.i;
        return (<li data-target={`#${id}`} data-slide-to={`${i}`} key={props.key}/>);
    };
    /**
     * Generate the rest list items after the initial active indicator
     */
    const generateListItems = (count, id) => {
        let listItems = [];
        for (let i = 1; i < count; i++) {
            listItems = listItems.concat([<ListItem id={id} key={`li-${i}`} i={i} />]);
        }
        return(listItems)
    };
    let newChildren = [];
    React.Children.toArray(props.children).forEach(child => {
        const newChild = (<div key={child.props.key} className={`item ${needsActive ? (" active") : ("")}`}>
            {child}
        </div>)
        needsActive = false;
        newChildren = newChildren.concat([newChild]);
    });
    return (
        <div
            id={id}
            className="carousel slide carousel-fade"
            data-ride="carousel"
            data-interval="false"
            style={{position: "relative"}}
        >
            <ol className="ps-carousel-indicators carousel-indicators">
                <li
                    data-target={`#${id}`}
                    data-slide-to="0"
                    className="active"
                    key="li--1"
                />
                {generateListItems(React.Children.count(props.children), id)}
            </ol>
            <div className="carousel-inner">
                {newChildren}
                <a className="ps-carousel-control left carousel-control" href={`#${id}`} role="button" data-slide="prev">
                    <span className="glyphicon glyphicon-chevron-left" style={{fontSize: "25px"}} aria-hidden="true"/>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="ps-carousel-control right carousel-control" href={`#${id}`} role="button" data-slide="next">
                    <span className="glyphicon glyphicon-chevron-right" style={{ fontSize: "25px" }} aria-hidden="true"/>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// app/helpers/Cards/Carousel.jsx